module.exports = __webpack_public_path__ + "static/media/rozeDel.0adc5cf6.jpg";